module.exports = __webpack_public_path__ + "static/media/scroll-down.9313c3af.svg";